const knownActionLabels = {
  approve: "Approve",
  assign: "Assign",
  create: "Create",
  delete: "Delete",
  export: "Export",
  manage: "Manage",
  read: "View",
  update: "Edit",
};

const preferredActionOrder = [
  "read",
  "create",
  "update",
  "delete",
  "manage",
  "export",
  "approve",
  "assign",
];

export const scopeTypeOptions = [
  { label: "Global", value: "global" },
  { label: "District", value: "district" },
  { label: "Sub-division", value: "sub_division" },
  { label: "Station", value: "station" },
];

export const toTitleCase = (value) =>
  String(value || "")
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const formatActionLabel = (action) =>
  knownActionLabels[action] || toTitleCase(action);

export const normalizeResourceName = (resource, labels = []) => {
  const matchingLabel = labels.find((label) => typeof label === "string" && label.includes(" - "));

  if (matchingLabel) {
    return matchingLabel
      .split(" - ")
      .slice(0, -1)
      .join(" - ")
      .trim();
  }

  return toTitleCase(resource);
};

export const buildPermissionKey = (resource, action) => `${resource}:${action}`;

export const isPermissionChecked = (selectedKeys, resource, action) =>
  selectedKeys.has(buildPermissionKey(resource, action));

export const togglePermission = (selectedKeys, resource, action) => {
  const nextKeys = new Set(selectedKeys);
  const permissionKey = buildPermissionKey(resource, action);

  if (nextKeys.has(permissionKey)) {
    nextKeys.delete(permissionKey);
  } else {
    nextKeys.add(permissionKey);
  }

  return nextKeys;
};

export const normalizeRoleKey = (label) =>
  String(label || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .replace(/_{2,}/g, "_");

export const isSnakeCase = (value) => /^[a-z0-9]+(?:_[a-z0-9]+)*$/.test(String(value || ""));

export const getActionColumns = (catalog) => {
  const actions = new Map();

  catalog.forEach((item) => {
    (item.actions || []).forEach((actionItem) => {
      if (!actionItem?.action) {
        return;
      }

      if (!actions.has(actionItem.action)) {
        actions.set(actionItem.action, {
          action: actionItem.action,
          label: formatActionLabel(actionItem.action),
        });
      }
    });
  });

  return Array.from(actions.values()).sort((left, right) => {
    const leftIndex = preferredActionOrder.indexOf(left.action);
    const rightIndex = preferredActionOrder.indexOf(right.action);
    const safeLeftIndex =
      leftIndex === -1 ? preferredActionOrder.length + 1 : leftIndex;
    const safeRightIndex =
      rightIndex === -1 ? preferredActionOrder.length + 1 : rightIndex;

    if (safeLeftIndex !== safeRightIndex) {
      return safeLeftIndex - safeRightIndex;
    }

    return left.label.localeCompare(right.label);
  });
};

export const getPermissionRows = (catalog) =>
  catalog.map((item) => {
    const actionMap = {};

    (item.actions || []).forEach((actionItem) => {
      if (actionItem?.action) {
        actionMap[actionItem.action] = actionItem;
      }
    });

    return {
      actionMap,
      labels: (item.actions || []).map((actionItem) => actionItem?.label).filter(Boolean),
      resource: item.resource,
      resourceLabel: normalizeResourceName(
        item.resource,
        (item.actions || []).map((actionItem) => actionItem?.label)
      ),
    };
  });
